import { User } from '../../types';

export namespace UserShared {
  export const Pages = {
    PROFILE: User.Pages.PROFILE,
  };

  export type User = User.Profile;

  export type UserRegister = User.RegisterProfile;
}
